import CollapsibleButton from './CollapsibleButton.jsx';

export default CollapsibleButton;
